import React from "react"
import HierarchyBreadCrumbItem from "../HierarchyBreadCrumbItem"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import * as hierarchySettingsActions from "../../../actions/HierarchySettingsActions"
import autobind from "class-autobind"
import { IHierarchyItem, IHierarchyItemForAccountLevel } from "../../../models"

interface IProps {
	clickableAccessHierarchies: string[]
	handleSelectHierarchyItem(selectedLevel: IHierarchyItem | IHierarchyItemForAccountLevel): void
}
interface IState {
	hierarchyList: IHierarchyItemForAccountLevel[]
}

export default class HierarchyBreadCrumb extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			hierarchyList: HierarchySettingsStore.getSelectedLevelItemPathToRoot()
		}
		autobind(this)
	}

	componentDidMount() {
		HierarchySettingsStore.on("change", this.changeEvent)
	}

	componentWillUnmount() {
		HierarchySettingsStore.removeListener("change", this.changeEvent)
	}

	changeEvent() {
		this.setState({ hierarchyList: HierarchySettingsStore.getSelectedLevelItemPathToRoot() })
	}

	onClick(level) {
		hierarchySettingsActions.receiveHierarchySelectedItem(level)
		this.props.handleSelectHierarchyItem(level)
	}

	render() {
		return (
			<div style={{ borderBottom: "solid 1px #cccccc" }}>
				{this.state.hierarchyList.map((item, i) =>
					<HierarchyBreadCrumbItem
						key={i}
						hierarchy={item.hierarchyItem}
						onClick={this.onClick}
						hierarchyDefinitionName={item.hierarchyDefinition.Label}
						hierarchyName={item.hierarchyItem.Label}
						disabled={!this.props.clickableAccessHierarchies.includes(item.hierarchyItem.Id ? item.hierarchyItem.Id : null)}
					/>
				)}
				<div style={{ clear: "both" }} />
			</div>
		)
	}
}